;(() => {
  if (document.querySelector('html').classList.contains('template-blog')) {
    const dropdownToggles = document.querySelectorAll(
      '.tag-filter-dropdown button.toggle-dropdown'
    )

    dropdownToggles.forEach((dropdown) => {
      dropdown.addEventListener('click', () => {
        dropdown.classList.toggle('active')
        const panel = dropdown.previousElementSibling
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px'
        }
      })
    })

    const loadMoreArticlesButton = document.querySelector(
      'button#load-more-blog-articles'
    )

    async function getNextPage(nextPageUrl) {
      try {
        const response = await fetch(`${nextPageUrl}&section_id=blog-articles`)
        const responseText = await response.text()
        const parser = new DOMParser()
        const doc = parser.parseFromString(responseText, 'text/html')

        const articleCards = doc.querySelectorAll('.article-card')
        const articlesGrid = document.querySelector('section.blog .grid')
        articleCards.forEach((article) => articlesGrid.appendChild(article))

        const thereMoreArticlesToLoad = doc.querySelector(
          'button#load-more-blog-articles'
        )
        if (thereMoreArticlesToLoad) {
          loadMoreArticlesButton.setAttribute(
            'data-next-page-url',
            thereMoreArticlesToLoad.getAttribute('data-next-page-url')
          )
        } else {
          loadMoreArticlesButton.remove()
        }
      } catch (error) {
        console.error('Error getting next page of blog articles: ', error)
      }
    }

    loadMoreArticlesButton?.addEventListener('click', function () {
      const nextPageUrl =
        loadMoreArticlesButton.getAttribute('data-next-page-url')
      getNextPage(nextPageUrl)
    })
  }
})()
